#import "../flexibleSections/flexibleSections.graphql"
#import "~/graphql/fragments/socialFragment.graphql"

fragment subsidyPageContent on subsidy_Entry {
    title
    uri
    description: plaintext

    helpCards {
        ... on page_Entry {
            title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext
            uri
        }

        ... on subsidy_Entry {
            title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext2
            uri
        }

        ... on informationPage_Entry {
            title
            icon
            dateUpdated
            isLastUpdatedRelevant: plainSwitch
            description: plaintext
            uri
            url
        }

        ... on externalLinks_default_Entry {
            title: plaintext
            icon
            description: textarea
            externalUrl
        }
    }

    seo {
        ... socialFragment
    }

    flexibleSections {
        ... flexibleSections
    }

    subsidyTargetAudienceRelation {
        id
    }

    subsidyPhaseRelation {
        id
        title
    }

    showNewsletterSubscribe
}
